export default __webpack_public_path__ + "static/media/product__update_fabric.16c36346.png";